"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadThemes = exports.FetchThemes = exports.FetchThemesActionTypes = exports.ThemeActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var ThemeActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_THEMES: null,
  FETCH_THEMES: null
}, 'shared');
exports.ThemeActionTypes = ThemeActionTypes;
var FetchThemesActionTypes = (0, _actions.createRequestTypes)(ThemeActionTypes.FETCH_THEMES);
exports.FetchThemesActionTypes = FetchThemesActionTypes;
var FetchThemes = (0, _actions.createRequestActions)(FetchThemesActionTypes);
exports.FetchThemes = FetchThemes;
var loadThemes = (0, _fluxActions.createAction)(ThemeActionTypes.LOAD_THEMES);
exports.loadThemes = loadThemes;